import { Locale } from '@headless-workspace/config';
import { ConfigByKeyRepository, Result, ResultEmpty, ResultSuccess } from '@headless-workspace/core-domain';
import { z } from 'zod';

export const LOCALITIES_CONFIG_KEY = 'woosmapApiKey';

export interface LocalitiesConfigRepositorySpec {
    fetchLocalitiesConfiguration(locale: Locale): Promise<Result<string>>;
}

export class LocalitiesConfigRepository extends ConfigByKeyRepository implements LocalitiesConfigRepositorySpec {
    async fetchLocalitiesConfiguration(locale: Locale): Promise<Result<string>> {
        const localitiesConfigsResult = await this.getConfigByKey(LOCALITIES_CONFIG_KEY, { locale }, (value) =>
            z.string().parse(value),
        );

        if (localitiesConfigsResult.type !== 'success') {
            return ResultEmpty();
        }

        return ResultSuccess(localitiesConfigsResult.data);
    }
}
